// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"0c923eba","175":"41da1aae","453":"f68d56ac","497":"d5055a10","508":"2bb213b0","724":"591d1283","934":"01a06797","947":"dfe5af01"}[chunkId] + ".chunk.js";
};